import type { ChangelogEntry } from "../types";

/** CRM fase 4: leads, møtebooking, påminnelser og møtereferat. */
export const CRM_FASE_4_LEADS_OG_MOTER_2026_10: ChangelogEntry = {
  id: "2026-10-17-crm-fase-4-leads-og-moter",
  date: "2026-10-17",
  title: "Leads og møter: ring, book og få referat uten å ta notater",
  summary:
    "Møtebookere ringer kalde leads ett om gangen og booker møter direkte i kalenderen til en kollega. Kunden får invitasjon og påminnelser, og etter møtet får verten et ferdig referat å godkjenne.",
  sections: [
    {
      heading: "Leads",
      items: [
        {
          title: "Ring leads ett om gangen",
          kind: "nytt",
          featureFlag: "feature_crm_leads_moter",
          body: "Under Salgsmuligheter, Leads får du ett lead om gangen fra listene DL har laget. Velg utfall med tastene: ikke svar (1), ikke relevant (2), ring tilbake (3), avtalt møte (4), notat (N) og hopp over (S). Leadet er ditt i 48 timer.",
        },
        {
          title: "Lister og segmenter",
          kind: "nytt",
          featureFlag: "feature_crm_leads_moter",
          minRole: "admin",
          body: "Lag lister fra en CSV-fil eller et søk i Enhetsregisteret, eller la en agent finne selskaper som passer en instruks. Under Leads ser du ringeaktivitet per møtebooker og utbytte per liste.",
        },
        {
          title: "Lead blir kunde ved første tilbud",
          kind: "nytt",
          featureFlag: "feature_crm_leads_moter",
          body: "Lager du tilbud på en prosess som kom fra et lead, opprettes kunden for deg med kontaktpersoner og møter, uten at noe sendes til PowerOffice.",
        },
      ],
    },
    {
      heading: "Møter",
      items: [
        {
          title: "Book møte",
          kind: "nytt",
          featureFlag: "feature_crm_leads_moter",
          body: "Fra et lead, en oppfølging, et signal, en prosess eller kundekortet (tast B i køen) velger du kontaktperson, tid og vert. Invitasjonen går fra vertens kalender med en Meet-lenke, og du ser hvem som er ledige.",
        },
        {
          title: "Påminnelser til kunden",
          kind: "nytt",
          featureFlag: "feature_crm_leads_moter",
          body: "Kunden får e-post dagen før og SMS tre timer og 15 minutter før møtet. Flytter eller avlyser verten møtet i kalenderen, følger påminnelsene med.",
        },
        {
          title: "Møtereferat",
          kind: "nytt",
          featureFlag: "feature_crm_leads_moter",
          body: "Meet tar opp transkripsjon, og verten får et referatutkast i køen: sammendrag, beslutninger og avtalte punkter. Verten retter, godkjenner og legger punkter i oppfølging. Rå transkripsjon slettes etter 90 dager, referatet beholdes.",
        },
      ],
    },
    {
      heading: "Køen",
      items: [
        {
          title: "Streak",
          kind: "nytt",
          featureFlag: "feature_crm_leads_moter",
          body: "Flammen ved «Din uke» teller uker på rad der du har gjort alle oppfølginger før salgsmøtet. DL ser streak per rådgiver som samtalegrunnlag, uten rangering.",
        },
      ],
    },
  ],
};
